const { getSignature, getTranslationDictionary } = require('core');
const { createDataUri, setViewData } = require('gui');
const collapsibleRegionPresenter = require('./collapsibleRegionPresenter');

module.exports = function signaturesPresenter(orderDto) {
    const c = {};
    const view = require('./signaturesPresenter.tpl.html');
    const translationDictionary = getTranslationDictionary();
    const signaturesString = translationDictionary.signatures;
    const signaturesRegionPresenter = collapsibleRegionPresenter(signaturesString);

    c.activate = function activate(region) {
        var proofOfDeparture = orderDto.proofOfDeparture || {};
        var proofOfDelivery = orderDto.proofOfDelivery || {};
        if(!(proofOfDeparture.id || proofOfDeparture.name || proofOfDelivery.id || proofOfDelivery.name))
            return;

        signaturesRegionPresenter.activate(region);
        view.activate(signaturesRegionPresenter.contentRegion());
        negotiateSignature(proofOfDeparture, view.proofOfDepartureImage, view.proofOfDepartureName);
        negotiateSignature(proofOfDelivery, view.proofOfDeliveryImage, view.proofOfDeliveryName);
    };

    c.deactivate = function deactivate() {
        view.proofOfDepartureImage.removeAttribute('src');
        view.proofOfDeliveryImage.removeAttribute('src');

        view.deactivate();
        signaturesRegionPresenter.deactivate();
    };

    function negotiateSignature(dto, imageElement, nameElement) {
        if(!(dto.id || dto.name))
            return;

        nameElement.textContent = dto.name ? dto.name : '';
        if (dto.id)
            getSignature(dto.id).then(response => {
                imageElement.src = createDataUri(response.MimeType, response.SignatureContents);
            });
    }

    return c;
}